<template>
  <div class="CustomerLevel">
    <div class="page-title">기계등급관리</div>
    <div>
      <ATable
        ref="table"
        :placeholder="placeholder"
        :search_field="search_field"
        :data="items"
        :disable_insert="!has_grant_write"
        hide-pagination
        border
        @cell-click="handleCellClick"
        @clicked-create="handleClickedCreate"
      >
        <el-table-column
          type="index"
          label="No"
          align="center"
          prop="index"
          :width="$width.index"
          :index="handleIndex"
        />
        <el-table-column label="등급명" prop="code" align="center" width="200">
          <template slot-scope="scope">
            <el-input
              size="mini"
              maxlength="10"
              :readonly="scope.row.id !== editingId"
              v-bind:class="{ 'readonly-noborder': scope.row.id !== editingId }"
              v-model="scope.row.code"
            />
          </template>
        </el-table-column>
        <el-table-column label="비고" prop="desc">
          <template slot-scope="scope">
            <el-input
              size="mini"
              :readonly="scope.row.id !== editingId"
              v-bind:class="{ 'readonly-noborder': scope.row.id !== editingId }"
              v-model="scope.row.desc"
            />
          </template>
        </el-table-column>
        <el-table-column label="명령" width="150">
          <template slot-scope="scope">
            <div v-show="scope.row.id === editingId">
              <el-button
                type="primary"
                size="mini"
                :disabled="!has_grant_write"
                :loading="load_button"
                @click="handleClickRegister(scope.row)"
                >저장</el-button
              >
              <el-button size="mini" @click="calcelEditing(scope.row)"
                >취소</el-button
              >
            </div>
            <div v-show="scope.row.id !== editingId">
              <el-button
                type="danger"
                size="mini"
                :disabled="!has_grant_write"
                :loading="load_button"
                @click="handleClickDelete(scope.row)"
                >삭제</el-button
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="created_user_name"
          :label="$t('lang.created_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="modified_user_name"
          :label="$t('lang.modified_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="created_at"
          :label="$t('lang.created_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="modified_at"
          :label="$t('lang.modified_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
      </ATable>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { authority_level } from "@/common/mixins/authority_level";
import { base_data } from "@/common/mixins/base_data";

export default {
  name: "CustomerLevel",
  mixins: [authority_level, base_data],
  data() {
    return {
      title: "기계등급",
      placeholder: "등급명, 비고",
      search_field: ["code", "desc"],
      items: [],
      editingId: -1,
      oldItem: undefined,
      deleteData: undefined,
      base_data: ["table_customer_level"],
      load_button: false,
    };
  },
  computed: {
    ...mapGetters(["table_customer_level"]),
    has_grant_write() {
      return this.isWriteLevel("customer_level");
    },
  },
  mounted() {
    this.init();
  },
  destroyed() {
    if (this.editingId < 0) {
      return;
    }
    this.calcelEditing(this.oldItem);
    this.editingId = -1;
  },
  methods: {
    init() {
      this.items = JSON.parse(JSON.stringify(this.table_customer_level));
    },
    calcelEditing(data) {
      let index = this.items.findIndex((i) => i.id === data.id);
      if (this.oldItem.id) {
        this.items.splice(index, 1, this.oldItem);
      } else {
        this.items.splice(index, 1);
      }
      this.editingId = -1;
    },
    doDelete() {
      this.load_button = true;
      this.api.deleteCustomerLevel(this.deleteData).then((res) => {
        this.load_button = false;
        this.handleResult(res, this.$t("message.success_delete"));
      });
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleClickedCreate() {
      if (this.editingId > -1) {
        this.calcelEditing(this.oldItem);
      }
      this.editingId = 0;
      this.oldItem = { id: 0, code: "", desc: null };
      this.items.push(this.oldItem);
    },
    handleCellClick(item, column) {
      if (this.editingId === item.id) {
        return;
      }
      if (this.editingId > -1) {
        this.calcelEditing(this.oldItem);
      }
      if (!column.property) {
        return;
      }
      this.editingId = item.id;
      this.oldItem = Object.assign({}, item);
    },
    handleClickRegister(data) {
      let isDuplicated = false;
      if (data.code.trim() === "") {
        this.util.notify_warning(this, this.title, "코드를 입력해주세요.");
        return;
      }
      this.items.forEach((item) => {
        if (item.id !== data.id && item.code === data.code) {
          isDuplicated = true;
        }
      });
      if (isDuplicated) {
        this.util.notify_warning(this, this.title, "중복된 코드입니다.");
        return;
      }
      this.load_button = true;
      if (data.id) {
        this.api.updateCustomerLevel(data).then((res) => {
          this.load_button = false;
          this.handleResultForSave(res);
        });
      } else {
        this.api.createCustomerLevel(data).then((res) => {
          this.load_button = false;
          this.handleResultForSave(res, true);
        });
      }
    },
    handleClickDelete(data) {
      this.deleteData = data;
      this.util.confirm_delete(
        this,
        this.title + "[" + data.code + "]",
        this.doDelete
      );
    },
    handleResultForSave(res, isCreate) {
      const message = isCreate
        ? this.$t("message.success_create")
        : this.$t("message.success_update");
      this.handleResult(res, message);
    },
    handleResult(res, successMessage) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.editingId = -1;
      this.util.notify(this, this.title, successMessage);
    },
  },
};
</script>
